// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import UserOutlined from 'C:/AIBook/aibook-admin/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UserOutlined';
import DesktopOutlined from 'C:/AIBook/aibook-admin/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DesktopOutlined';
import FileOutlined from 'C:/AIBook/aibook-admin/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/FileOutlined';
import HighlightOutlined from 'C:/AIBook/aibook-admin/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/HighlightOutlined';
import SettingOutlined from 'C:/AIBook/aibook-admin/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { UserOutlined, DesktopOutlined, FileOutlined, HighlightOutlined, SettingOutlined };
